import { combineReducers } from 'redux';
import { createToggleAndSetReducer } from '../../../redux-util/general-helpers';
import * as act from './actions';

export default combineReducers({
  searchActive: createToggleAndSetReducer(
    act.toggleSearch().type,
    act.setSearch().type,
    false
  ),
});



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/common/library/reducer.js